import React from "react";
import AdminDashboard from "../components/AdminComponent";

const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3005';

export default function AdminPage() {
  
  const fetchDashboardData = async () => {
    const token = localStorage.getItem("token");
    
    if (!token) {
      alert("No estás autenticado. Por favor, inicia sesión.");
      window.location.href = "/";
      return null;
    }

    try {
      // Obtener estadísticas de todos los endpoints
      const endpoints = ['users', 'projects', 'companies', 'events', 'meetings'];
      const promises = endpoints.map(endpoint =>
        fetch(`${baseUrl}/${endpoint}`, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }).then(res => res.json())
      );

      const [usuarios, proyectos, companias, eventos, reuniones] = await Promise.all(promises);
      console.log({ usuarios, proyectos, companias, eventos, reuniones });

      // Calcular estadísticas
      const stats = {
        usuarios: usuarios?.length || 0,
        proyectos: {
          total: proyectos?.length || 0,
          pendientes: proyectos?.filter(p => p.accepted === false || p.accepted === undefined)?.length || 0
        },
        companias: {
          total: companias?.length || 0,
          pendientes: 0
        },
        eventos: {
          total: eventos?.length || 0,
          pendientes: 0
        },
        reuniones: {
          total: reuniones?.length || 0,
          pendientes: 0
        }
      };

      return stats;

    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      alert('Error al cargar los datos del dashboard');
      return null;
    }
  };

  const navigateToPanel = (tab, subTab = null) => {
    const url = subTab 
      ? `/admin/panel?tab=${tab}&subtab=${subTab}`
      : `/admin/panel?tab=${tab}`;
    window.location.href = url;
  };

  const navigateToFullPanel = () => {
    window.location.href = "/admin/panel";
  };

  return React.createElement(AdminDashboard, { 
    fetchDashboardData,
    navigateToPanel,
    navigateToFullPanel 
  });
}
